<template>
  <el-row>
    <el-col style="padding: 30px">
      <div class="label-contract">
        {{ $t('remark') }}:
        <div style="float: right">
          <el-button type="primary" size="mini" plain
                     @click="resetToCurrentVersion">
            {{ $t('resetToCurrentVersion') }}
          </el-button>
          <el-button type="default" size="mini" plain @click="resetToDefaultSetting" v-if="isShowDefaultButton">{{ $t('resetToDefaultSetting') }}</el-button>
        </div>
      </div>
      <div class="el-form-item__content">
        <editor-component v-model="remarkContent"></editor-component>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import i18nMessages from '@/translations/Contract/components/RemarkComponent.i18n'
import EditorComponent from '@/components/EditorComponent'
import { get } from 'lodash'
import { getContractRemark } from '@/helpers'

export default {
  name: 'RemarkComponent',
  i18n: { messages: i18nMessages },
  components: { EditorComponent },
  props: {
    remarkType: {
      type: String,
      default: ''
    },
    remarkList: {
      type: Array,
      default: function () {
        return []
      }
    },
    isShowDefaultButton: {
      type: Boolean,
      default: function () {
        return true
      }
    },
    contractDetail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      contractPromotionRemarkTmp: ''
    }
  },
  created: function () {
    this.contractPromotionRemarkTmp = getContractRemark(this.contractDetail, this.remarkType)
  },
  computed: {
    remarkContent: {
      get () {
        const remarkList = get(this.contractDetail, 'remarkList', [])
        const remark = remarkList.find(item => item.remarkType === this.remarkType)
        let remarkContent = get(remark, 'content', '')

        if (remark === undefined) {
          const defaultRemark = this.remarkList.find(remark => remark.remarkType === this.remarkType)
          remarkContent = get(defaultRemark, 'content', '')
        }

        return remarkContent
      },
      set (newVal) {
        const newRemark = {
          remarkType: this.remarkType,
          content: newVal
        }

        this.$emit('onRemarkChange', newRemark)
      }
    }
  },
  methods: {
    resetToCurrentVersion: function () {
      this.remarkContent = this.contractPromotionRemarkTmp
    },
    resetToDefaultSetting: function () {
      const defaultRemark = this.remarkList.find(remark => remark.remarkType === this.remarkType)
      this.remarkContent = get(defaultRemark, 'content', '')
    }
  }
}
</script>

<style scoped>
  .el-form-item__content {
    line-height: 22px;
  }
</style>
